module.exports = __webpack_public_path__ + "img/vascular-care-group-logo.a48cdbf9.svg";